import "./DestinationStyles.css";
import DestinationData from "./DestinationData";

import Mountain1 from "../assets/1.jpg";
import Mountain2 from "../assets/2.jpg";
import Mountain3 from "../assets/5.jpg";
import Mountain4 from "../assets/8.jpg";

const Destination = () => {
  return (
    <>
      <div className="destination">
        <h1>Popular Destinations</h1>
        <p>Tours give you the opportunity to see a lot, within a time frame</p>

        {/* <div className="first-des">
          <div className="des-text">
            <h2> Taal Volcano Batangas </h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi
              voluptas non veritatis, explicabo distinctio aut vel sapiente est
              obcaecati? Soluta libero laboriosam repudiandae temporibus nisi!
              Quas et, laudantium a dicta sequi minima blanditiis magni
              sapiente, unde eum doloremque autem mollitia sit aliquam corrupti
              repellendus rerum quaerat expedita id sint iure!
            </p>
          </div>
          <div className="image">
            <img src={Mountain1} alt="" />
            <img src={Mountain2} alt="" />
          </div>
        </div> */}
        <DestinationData
          className="first-des"
          heading="Taal Volcano Batangas"
          text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi voluptas non veritatis, explicabo distinctio aut vel sapiente est obcaecati? Soluta libero laboriosam repudiandae temporibus nisi! Quas et, laudantium a dicta sequi minima blanditiis magni sapiente, unde eum doloremque autem mollitia sit aliquam corrupti repellendus rerum quaerat expedita id sint iure!"
          img1={Mountain1}
          img2={Mountain2}
        />

        <DestinationData
          className="first-des-reverse"
          heading="MT.Daguldul, Batangas"
          text="Lorem, ipsum dolor sit amet consectetur adipisicing elit. Inventore reiciendis odio ipsa ex repellat! Iusto ducimus, quasi perferendis deserunt odio voluptatibus accusantium, laboriosam neque molestias facilis quisquam ex delectus doloribus aspernatur accusamus ea? Quisquam animi nemo ex quas dolorem veniam fuga amet asperiores facere. Voluptatem eius rerum rem quam nobis."
          img1={Mountain3}
          img2={Mountain4}
        />
      </div>
    </>
  );
};

export default Destination;
